<template>
  <div class>
    <div class="event-setup-wrapper event-basic-setup-wrap-admin">
      <div class="container-fluid pt-4 pb-8">
        <!-- <SelfServiceLeftMenu>
        </SelfServiceLeftMenu> -->
        <div class="right-setup-wrap" style="">
          <div v-if="EventData" class="event-add-setup-form">
            <v-row class="px-4">
              <v-col md="6" sm="6" cols="12" class="d-none">
                <div class="streaming-client-left">
                  <h4>Streaming Client</h4>
                  <div class="radio-custom-group">
                    <v-radio-group
                      v-model="EventData.StreamingClient"
                      mandatory
                    >
                      <v-radio
                        label="Zoom"
                        value="Zoom"
                        class="mr-2"
                        active-class="active-item"
                      ></v-radio>
                      <v-icon color="#959595" size="20px" class="mr-4"
                        >mdi-information-outline</v-icon
                      >
                      <v-radio
                        label="Web"
                        value="Web"
                        class="mr-2"
                        active-class="active-item"
                      ></v-radio>
                      <v-icon color="#959595" size="20px"
                        >mdi-information-outline</v-icon
                      >
                    </v-radio-group>
                  </div>
                </div>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <div class="streaming-client-left position-relative">
                  <h4>
                    Access
                    <!-- <v-icon
                      color="#959595"
                      size="20px"
                      class="ml-2"
                      @mouseover="showEventAccessDialog = true"
                      @mouseleave="showEventAccessDialog = false"
                      >mdi-information-outline</v-icon
                    > -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="#959595"
                          size="20px"
                          class="ml-2"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-information-outline</v-icon
                        >
                      </template>

                      <div>
                        <p class="mb-0"><strong>Public:</strong></p>
                        <p>
                          Anyone can discover <br />
                          and register for a <br />
                          Public event (they will be indexed <br />
                          by search engines).
                        </p>
                        <p class="mb-0"><strong>Private:</strong></p>

                        <p style="margin: auto">
                          Events which do not <br />require self
                          registration.<br />Event planners send invitation and
                          <br />
                          login info to join the event.
                        </p>
                      </div>
                    </v-tooltip>
                  </h4>
                  <!-- <v-dialog v-model="showEventAccessDialog" max-width="290">
                    <v-card>
                      <div class="event-type-head-tooltip p-5">
                        <p class="mb-0"><strong>Public:</strong></p>
                        <p>
                          Anyone can discover and register for a Public event
                          (they will be indexed by search engines).
                        </p>
                        <p class="mb-0"><strong>Private:</strong></p>

                        <p style="margin: auto">
                          Events which do not require self registration. Event
                          planners send invitation and login info to join the
                          event.
                        </p>
                      </div>
                    </v-card>
                  </v-dialog> -->

                  <div class="access-switch">
                    <div class="custom-switch-field">
                      <input
                        type="radio"
                        id="radio-one"
                        name="switch-one"
                        value="2"
                        v-model="EventData.EventTypeId"
                      />
                      <label for="radio-one"
                        ><v-icon color="#959595" size="20px">mdi-earth</v-icon>
                        Public</label
                      >
                      <input
                        type="radio"
                        id="radio-two"
                        name="switch-one"
                        value="1"
                        v-model="EventData.EventTypeId"
                      />
                      <label for="radio-two"
                        ><v-icon color="#959595" size="20px">mdi-lock</v-icon>
                        Private</label
                      >
                    </div>
                  </div>
                  <div
                    v-show="EventData.EventTypeId == 2  && false"
                    class="streaming-client-right ml-4"
                  >
                    <v-checkbox
                      v-model="EventData.AllowRegistration"
                      color="#959595"
                      hide-details
                      label="Allow Registration"
                      class="p-0 m-0 text-nowrap"
                    ></v-checkbox>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col md="6" sm="6" cols="12">
                <label>Event Name</label>

                <v-text-field
                  outlined
                  type="Text"
                  :rules="[(v) => !!v || 'This field is required']"
                  required
                  class="ss-cns-name"
                  placeholder="Enter Event Name"
                  v-model="EventData.EventFullName"
                  counter
                  maxlength="200"
                ></v-text-field>
                <!-- <input
                  id="txtEventFullName"
                  type="text"
                  class="custom-input"
                  v-model="EventData.EventFullName"
                /> -->
              </v-col>
              <v-col md="6" sm="6" cols="12">
                <label>Event Type</label>
                <input
                  v-if="EventData.LocationType"
                  readonly
                  type="text"
                  class="custom-input"
                  v-model="EventData.LocationType.Name"
                />
                <!-- <v-select
                  outlined
                  label="Select a Event Type"
                  :items="locationOptions"
                  item-text="Name"
                  return-object
                  v-model="EventData.LocationType"
                ></v-select> -->
              </v-col>
              <v-col md="6" sm="6" cols="12">
                <label>Time Zone</label>
                <v-select
                  outlined
                  label="Select a Time Zone"
                  :items="TimeZones"
                  item-text="label"
                  item-value="value"
                  v-model="EventData.TimeZone"
                ></v-select>
              </v-col>
              <v-col md="6" sm="6" cols="12" class="mt-3">
                <v-row>
                  <v-col md="6" sm="6" cols="12">
                    <label>Start</label>
                    <flat-pickr
                      placeholder="MM/DD/YYYY"
                      class="text-uppercase custom-input"
                      v-model="EventData.EventStartDateTime"
                      :config="configdateTimePickerStart"
                    />
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <label>End</label>
                    <flat-pickr
                      placeholder="MM/DD/YYYY"
                      class="text-uppercase custom-input"
                      v-model="EventData.EventEndDateTime"
                      :config="configdateTimePickerEnd"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col md="6" sm="6" cols="12">
                <label
                  >Login Authentication {{ EventData.EventAccessType }}</label
                >
                <v-select
                  outlined
                  disabled
                  label="Select a Login Authentication"
                  :items="PasscodeOptions"
                  v-model="EventData.EventAccessType"
                ></v-select>
              </v-col>
              <v-col md="6" sm="6" cols="12">
                <label>Default Event language</label>
                <v-select
                  outlined
                  label="Select a Language"
                  :items="LanguageOptions"
                  v-model="EventData.DefaultLanguage"
                ></v-select>
              </v-col> -->
              <v-col cols="12" md="12" sm="12">
                <div class="d-flex justify-content-between align-items-end">
                  <label>Description</label>
                  <v-btn class="ma-2 d-none" outlined color="#1a73e8"
                    >Edit Speaker</v-btn
                  >
                </div>
                <ckeditor
                  class="desc-event"
                  v-model="EventData.Description"
                  :config="editorConfig"
                >
                </ckeditor>
              </v-col>

              <div class="apply-theme mt-5 pt-5">
                <h3>Apply theme<span>(Optional)</span></h3>
                <ul>
                  <li>
                    <div
                      class="theme-select"
                      @click="appColorHexCodeType = 'headerColorsHexCodeDark'"
                    >
                      <img src="../assets/Images/dark-theme.png" />
                      <div
                        :class="
                          appColorHexCodeType == 'headerColorsHexCodeDark'
                            ? 'Selected-theme active'
                            : 'Selected-theme'
                        "
                      >
                        <img src="../assets/Images/reg-ico/selected.svg" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      class="theme-select"
                      @click="appColorHexCodeType = 'headerColorsHexCodeLight'"
                    >
                      <img src="../assets/Images/bright-theme.png" />
                      <div
                        :class="
                          appColorHexCodeType == 'headerColorsHexCodeLight'
                            ? 'Selected-theme active'
                            : 'Selected-theme'
                        "
                      >
                        <img src="../assets/Images/reg-ico/selected.svg" />
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="custom-logo-banner-upload d-none">
                  <p>
                    <v-checkbox
                      color="#959595"
                      value="red"
                      hide-details
                    ></v-checkbox>
                    Upload Custom Logo &amp; Banner
                  </p>
                </div>
              </div>

              <div class="hosted-section pt-8 mt-8 d-none" v-if="HostInfo">
                <h3>Hosted By<span>(Optional)</span></h3>
                <v-row class="mt-8">
                  <v-col md="6" sm="6" cols="12">
                    <label>Host Name {{ HostInfo.Name }}</label>
                    <input
                      type="text"
                      placeholder="Enter host name"
                      v-model="HostInfo.Name"
                    />

                    <label>Host Short profile</label>

                    <ckeditor
                      class="desc-event"
                      v-model="HostInfo.Profile"
                      :config="editorConfig"
                    >
                    </ckeditor>
                  </v-col>
                  <v-col md="6" sm="6" cols="12">
                    <div class="drag-drop-sponsor-logo">
                      <input type="file" value="" class="select-file" />
                      <img v-if="HostInfo.Logo" :src="HostInfo.Logo" />
                      <img v-else src="../assets/Images/reg-ico/img-icon.svg" />
                      <h4>click to add host logo</h4>
                      <p>960x192px PNG, JPG Max 3MB</p>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-row>
          </div>
          <div
            class="d-flex mt-8 justify-content-end align-items-center"
            style="display: none !important"
          >
            <v-btn
              class="mr-2 cancel-standard"
              outlined
              color="#1c1d26"
              @click="CancelBasicSetup"
              width="100px"
            >
              Cancel
            </v-btn>

            <v-btn
              v-if="EventData"
              class="px-6 save-standard"
              dark
              color="#2376e5"
              @click="SaveBasicSetup"
              width="100px"
              :loading="SaveingBasicSetup"
            >
              Save
            </v-btn>
          </div>
          <!-- <div class="custom-event-basic-setup-wrap">
          <h3>Basic Info</h3>
          <h4>Event Name &amp; Type</h4>
          <div
            v-if="EventData"
            class="event-add-setup-form"
          >
            <v-row class="mt-4">
              <v-col cols="12" md="12" lg="12">
                <label>Event Name*</label>
                <input
                  id="txtEventFullName"
                  type="text"
                  class="custom-input"
                  v-model="EventData.EventFullName"
                />
              </v-col>
              <v-col cols="12" md="12" lg="12">
                <label>Host Name</label>
                <input
                  id="txtEventFullName"
                  type="text"
                  class="custom-input"
                />
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <label>Event Type</label>
                <v-select
                  outlined
                  label="Select a Event Type"
                  :items="locationOptions"
                  item-text="Name"
                  return-object
                  v-model="EventData.LocationType"
                ></v-select>
                <p class="virtualevent-txt">Virtual events have unique event pages where you can add links to livestreams and more</p>
              </v-col>
            </v-row>
            <h4>Date and Time</h4>
            <p>Tell event-goers when your event starts and ends so they can make plans to attend.</p>
            <v-row class="mt-4">
              <v-col md="12" sm="12" cols="12">
                <label>Time Zone</label>
                <v-select
                  outlined
                  label="Select a Time Zone"
                  :items="TimeZones"
                  item-text="label"
                  item-value="value"
                  v-model="EventData.TimeZone"
                ></v-select>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                  <v-row>
                    <v-col md="6" sm="6" cols="12">
                      <label>Start</label>
                      <flat-pickr
                        placeholder="MM/DD/YYYY"
                        class="text-uppercase custom-input"
                        v-model="EventData.EventStartDateTime"
                        :config="configdateTimePickerStart"
                      />
                     
                    </v-col>
                    <v-col md="6" sm="6" cols="12">
                      <label>End</label>
                      <flat-pickr
                        placeholder="MM/DD/YYYY"
                        class="text-uppercase custom-input"
                        v-model="EventData.EventEndDateTime"
                        :config="configdateTimePickerEnd"
                      />
                      
                    </v-col>
                  </v-row>
                </v-col>
            </v-row>
          </div>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import APIs from "@/components/APIInit";
import axios from "axios";
import store from "@/store";
// import jQuery from "jquery";
// let $ = jQuery;
import { bus } from "@/main";
// import db from "../components/firebaseInit";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
import common from "@/common";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
//import SelfServiceLeftMenu from "@/components/SelfServiceLeftMenu.vue";

var vm;
export default {
  components: {
    ckeditor: CKEditor.component,
    flatPickr,
    //SelfServiceLeftMenu,
  },
  data() {
    return {
      showEventAccessDialog: false,
      editorConfig: CKconfig.editorConfig,
      radios2: null,
      locationOptions: [
        { Id: 1, Name: "In-person" },
        { Id: 2, Name: "Virtual" },
        { Id: 3, Name: "Hybrid" },
      ],
      TimeZones: [{ label: "Select a Time Zone", value: "" }],
      PasscodeOptions: [
        "Unique Passcode per Attendee",
        "Use Common Event Passcode",
      ],
      LanguageOptions: ["Chinese", "English", "French", "German"],
      configdateTimePickerStart: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
          if (val) {
            if (
              new Date(val).getTime() >
              new Date(vm.EventData.EventEndDateTime).getTime()
            ) {
              vm.EventData.EventEndDateTime = new Date(val).setHours(
                new Date(val).getHours() + 1
              );
            }
          }
        },
      },
      configdateTimePickerEnd: {
        minDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      ex4: ["red"],
      //event_collectionName: "",
      EventData: {},
      HostInfo: {},
      SaveingBasicSetup: false,
      LightTheme: {
        topBar: "#FFFFFF",
        headerBar: "#FFFFFF",
        fontBar: "#000000",
        sideNavigationAndIconColor: "#64656E",
      },
      DarkTheme: {
        topBar: "#000000",
        headerBar: "#000000",
        fontBar: "#3a3a3a",
        sideNavigationAndIconColor: "#000000",
      },
      appColorHexCodeType: "",
      headerColorsHexCode: {},
      hostName: "",
      clientName: "",
      customDomain: "",
      clientId: null,
      eventId: null,
    };
  },
  computed: {},
  watch: {
    "EventData.EventTypeId": function (val) {
      if (val == 1) {
        vm.EventData.AllowRegistration = false;
      } else {
        vm.EventData.AllowRegistration = true;
      }
    },
  },
  created() {
    vm = this;
    bus.$on("OnSaveAndNextEventInfo", () => {
      vm.SaveEventInfo();
    });
  },
  mounted() {
    // vm.noEventLink = vm.$t("client.registerRoute");
    // vm.clientID = vm.$route.query.c;
    // vm.tokenForUser = vm.$route.query.sst;
    // if (vm.tokenForUser != "") {
    //   vm.registerUserForEventAdmin();
    // }
    vm.event_collectionName = vm.getEventCollectionName();
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.TimeZones = [{ label: "Select a Time Zone", value: "" }].concat(
      common.getTimeZones()
    );
    vm.GetEventDetails();
    setTimeout(() => {
      var el = document.getElementById("txtEventFullName");
      if (el) {
        el.focus();
      }
    }, 500);
  },
  destroyed() {
    bus.$off("OnSaveAndNextEventInfo");
  },
  methods: {
    async GetEventDetails() {
      vm.EventData = vm.getCurrentEvent();
      vm.EventData.EventStartDateTime = this.SetTimeByZone(
        new Date(vm.EventData.EventStartDate.seconds * 1000).toUTCString(),
        vm.EventData.TimeZone
      );
      vm.EventData.EventEndDateTime = this.SetTimeByZone(
        new Date(vm.EventData.EventEndDate.seconds * 1000).toUTCString(),
        vm.EventData.TimeZone
      );

      var brandingData = await vm.getBrandingJSONDetails(
        vm.event_collectionName + "/Branding/Branding.json"
      );
      if (brandingData && brandingData.data && brandingData.data.HostInfo) {
        var hostInfo = brandingData.data.HostInfo;
        vm.HostInfo = new Object();
        vm.HostInfo.Name =
          hostInfo && hostInfo.Name == undefined ? "" : hostInfo.Name;
        vm.HostInfo.Profile =
          hostInfo && hostInfo.Profile == undefined ? "" : hostInfo.Profile;
        vm.HostInfo.Logo =
          hostInfo && hostInfo.Logo == undefined ? "" : hostInfo.Logo;
        // alert(vm.EventData.EventStartTimestamp)
        // alert(vm.EventData.EventStartDate)
        vm.EventData.EventStartTimestamp =
          vm.EventData.EventStartDate == undefined
            ? 0
            : vm.EventData.EventStartDate.seconds * 1000;
        vm.EventData.EventEndTimestamp =
          vm.EventData.EventEndDate == undefined
            ? 0
            : vm.EventData.EventEndDate.seconds * 1000;
        var dateFormat = require("dateformat");
        vm.EventData.EventStartDateStr = dateFormat(
          new Date(vm.EventData.EventStartTimestamp),
          "mm/dd/yyyy"
        );
        vm.EventData.EventEndDateStr = dateFormat(
          new Date(vm.EventData.EventEndTimestamp),
          "mm/dd/yyyy"
        );
        //vm.EventData.EventStartDateStr = "10/16/2020";
        //vm.EventData.EventEndDateStr = dateFormat(new Date(vm.EventData.EventEndTimestamp), "yyyy-mm-dd");
        vm.appColorHexCodeType = brandingData.data["appColorHexCodeType"];
        vm.headerColorsHexCode = brandingData.data["headerColorsHexCode"];
        //alert(vm.appColorHexCodeType)
      }
      // vm.EventData = {
      //   EventFullName: "aaaaaa",
      //   LocationType: { Id: 1, Name: "In-person" },
      //   EventTypeId: 1,
      // };
    },
    async GetEventDetails2() {
      axios
        .get(
          APIs.EventBrandingJsonData +
            "?iid=OA_UAT" +
            "&cid=" +
            vm.clientId +
            "&eid=" +
            vm.eventId
        )
        .then(async (res) => {
          console.log("res===2", res.data);
          if (res.data.status == 0) {
            var brandingData = res.data.result;

            vm.HostInfo = brandingData.HostInfo;
            vm.clientName = brandingData.HostInfo.Name;
            vm.clientLogoUrl = brandingData.HostInfo.Logo;
            vm.clientProfile = brandingData.HostInfo.Profile;

            // if (brandingData.ClientInfo) {
            //   vm.desktopBanner =
            //     brandingData.ClientInfo.EventListAssets.banner2048x88;
            //   vm.mobileBanner =
            //     brandingData.ClientInfo.EventListAssets.banner750x103;
            //   // vm.BannerURL =
            //   //   brandingData.ClientInfo.EventListAssets.banner2048x88;
            // }
            // // else {
            // //   vm.BannerURL == "";
            // // }
            var dateFormat = require("dateformat");

            console.log(brandingData.EventInfo.EventFullName);
            var obj = new Object();

            obj.EventFullName = brandingData.EventInfo.EventFullName;
            obj.IsPublished = brandingData.EventInfo.IsPublished;

            obj.EventTimezone = brandingData.EventInfo.TimeZone; // moment.tz.guess();
            //obj.EventTimezoneZ = moment.tz.guess();

            // console.log(
            //   "response.data.EventInfo:- " + brandingData.EventInfo
            // );
            obj.EventLogo = brandingData.EventInfo.EventLogo;
            obj.EventBannerShare = brandingData.EventInfo.EventBannerShare;
            obj.Description = brandingData.EventInfo.Description;
            vm.AllowRegistration =
              brandingData.EventInfo.AllowRegistration == undefined
                ? true
                : brandingData.EventInfo.AllowRegistration;
            obj.EventStartDate = dateFormat(
              brandingData.EventInfo.EventStartDate,
              "mmm dd, hh:MM TT"
            );
            obj.EventEndDate = dateFormat(
              brandingData.EventInfo.EventEndDate,
              "mmm dd, hh:MM TT"
            );
            obj.EventStartDateZ = vm.GetTimeByZone(
              brandingData.EventInfo.EventStartDate,
              brandingData.EventInfo.TimeZone
            );
            obj.EventStartTimestamp = parseInt(
              obj.EventStartDateZ.getTime() / 1000
            );
            obj.EventStartDateZ = dateFormat(
              obj.EventStartDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventEndDateZ = vm.GetTimeByZone(
              brandingData.EventInfo.EventEndDate,
              brandingData.EventInfo.TimeZone
            );
            obj.EventEndTimestamp = parseInt(
              obj.EventEndDateZ.getTime() / 1000
            );
            obj.EventEndDateZ = dateFormat(
              obj.EventEndDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventDateStringLabel =
              obj.EventStartDate != obj.EventEndDate
                ? obj.EventStartDate +
                  " to " +
                  obj.EventEndDate +
                  " " +
                  obj.EventTimezoneZ
                : obj.EventStartDate + " " + obj.EventTimezoneZ;

            vm.EventData = obj;
            vm.EventData = brandingData.EventInfo;
            console.log(vm.EventData);
          }
        });
    },
    SaveBasicSetup() {
      vm.SaveEventInfo();
      //vm.$emit("OnUpdateBasicSetupSuccess");
    },
    CancelBasicSetup() {
      vm.$emit("OnCancelBasicSetupSuccess");
    },
    SaveEventInfo() {
      vm.SaveingBasicSetup = true;
      bus.$emit("toggleLoader", true);
      let dataObj = new Object();
      if (!vm.EventData.EventFullName) {
        vm.SaveingBasicSetup = false;
        bus.$emit("toggleLoader", false);
        bus.$emit("StopNextLoader");
        this.showSnackbar("Event Name cannot be empty", "error", "top");
        return;
      }
      dataObj.EventFullName = vm.EventData.EventFullName;
      dataObj.EventShortName = vm.EventData.EventFullName;
      dataObj.Description = vm.EventData.Description
        ? vm.EventData.Description
        : "";
      dataObj.EventType = vm.EventData.EventTypeId;
      dataObj.EventTypeId = vm.EventData.EventTypeId;
      dataObj.AllowRegistration =
        vm.EventData.EventTypeId == 2 && vm.EventData.AllowRegistration;
      // dataObj.Description = vm.EventData.Name;
      // dataObj.Description = vm.EventData.Name;
      //dataObj.LocationType = vm.EventData.LocationType;
      dataObj.LocationType = { Id: 2, Name: "Virtual" };
      dataObj.TimeZone = vm.EventData.TimeZone;
      // dataObj.StartDate = new Date(vm.EventData.EventStartDateStr);
      // dataObj.EndDate = new Date(vm.EventData.EventEndDateStr);

      // dataObj.StartDateTZ = moment(vm.EventData.EventStartDateTime).format(
      //   "MMM DD, YYYY"
      // );
      // dataObj.StartTimeTZ = moment(vm.EventData.EventStartDateTime).format(
      //   "hh:mm A"
      // );
      // dataObj.EndDateTZ = moment(vm.EventData.EventEndDateTime).format(
      //   "MMM DD, YYYY"
      // );
      // dataObj.EndTimeTZ = moment(vm.EventData.EventEndDateTime).format(
      //   "hh:mm A"
      // );
      debugger;

      if (!vm.EventData.EventStartDateTime || !vm.EventData.EventEndDateTime) {
        vm.SaveingBasicSetup = false;
        bus.$emit("toggleLoader", false);
        bus.$emit("StopNextLoader");
        this.showSnackbar("Start/End date cannot be empty", "error", "top");
        return;
      }

      dataObj.EventStartDate = vm.GetTimeByZone(
        vm.EventData.EventStartDateTime,
        vm.EventData.TimeZone
      );
      dataObj.EventEndDate = vm.GetTimeByZone(
        vm.EventData.EventEndDateTime,
        vm.EventData.TimeZone
      );
      // dataObj.EventStartDate = vm.EventData.EventStartDateTime;
      // dataObj.EventEndDate = vm.EventData.EventEndDateTime;
      dataObj.StartDate = dataObj.EventStartDate;
      dataObj.EndDate = dataObj.EventEndDate;
      dataObj.DefaultLanguage = vm.EventData.DefaultLanguage;
      dataObj.EventAccessType = vm.EventData.EventAccessType;
      //alert(dataObj.TimeZone);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: dataObj,
      };
      axios
        .post(APIs.SaveEventAPI, requestData, { headers: headers })
        .then(function (res) {
          vm.SaveingBasicSetup = false;
          bus.$emit("toggleLoader", false);
          if (res.data.status == 200) {
            vm.showSnackbar("Event info updated", "success", "top");

            var StartDateTimeStamp = parseInt(
              dataObj.StartDate.getTime() / 1000
            );
            var EndDateTimeStamp = parseInt(dataObj.EndDate.getTime() / 1000);

            delete dataObj.EventType;
            delete dataObj.StartDate;
            delete dataObj.EndDate;
            delete dataObj.StartDateTimeStamp;
            delete dataObj.EndDateTimeStamp;
            dataObj.EventStartDate = moment
              .tz(
                dataObj.EventStartDate ? dataObj.EventStartDate : new Date(),
                dataObj.TimeZone
              )
              .format("YYYY-MM-DDTHH:mm:SS");
            dataObj.EventEndDate = moment
              .tz(
                dataObj.EventEndDate ? dataObj.EventEndDate : new Date(),
                dataObj.TimeZone
              )
              .format("YYYY-MM-DDTHH:mm:SS");
            dataObj.StartDateTimeStamp = {
              seconds: StartDateTimeStamp,
              nanoseconds: 0,
            };
            dataObj.EndDateTimeStamp = {
              seconds: EndDateTimeStamp,
              nanoseconds: 0,
            };

            var themeChanged = false;
            if (
              store.state.EventBranding &&
              store.state.EventBranding.length > 0 &&
              store.state.EventBranding[0].themeName
            ) {
              if (
                store.state.EventBranding[0].themeName != vm.appColorHexCodeType
              ) {
                themeChanged = true;
              }
            }
            if (themeChanged) {
              if (vm.appColorHexCodeType == "headerColorsHexCodeLight") {
                vm.headerColorsHexCode = vm.LightTheme;
              } else if (vm.appColorHexCodeType == "headerColorsHexCodeDark") {
                vm.headerColorsHexCode = vm.DarkTheme;
              }
              //vm.setBannerKey(brandingSessionKey, brandingSubKeyValue);
            }
            vm.setBrandingJson([
              { key: "EventInfo", obj: dataObj },
              {
                key: null,
                obj: { appColorHexCodeType: vm.appColorHexCodeType },
              },
              { key: "headerColorsHexCode", obj: vm.headerColorsHexCode },
            ]);

            // dataObj.StartDateTimeStamp = StartDateTimeStamp;
            // dataObj.EndDateTimeStamp = EndDateTimeStamp;
            vm.UpdateLocalStorage(dataObj);
            bus.$emit("SaveStepStatus", "visited", true);
            bus.$emit("resetSelfServiceLeftMenu");
            //vm.$emit("OnUpdateBasicSetupSuccess");
            //SaveStepStatus
            if (themeChanged) {
              // bus.$emit("toggleLoader", true);
              setTimeout(() => {
                vm.showSnackbar("Applying Theme...", "success", "top");
              }, 5100);
              // bus.$emit("toggleLoader", false);
            }
          } else {
            vm.showSnackbar("Data not updated!", "error", "top");
          }
        })
        .catch((e) => {
          console.log(e);
          vm.SaveingBasicSetup = false;
          bus.$emit("toggleLoader", false);
          vm.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    UpdateLocalStorage(dataObj) {
      if (dataObj) {
        this.$store.state.locale = dataObj.DefaultLanguage;
        store.commit("addEventName", dataObj.EventFullName);
        //store.commit("addEventSdate", dataObj.EventStartDate);
        store.commit("addEventSdate", dataObj.StartDateTimeStamp);
        //store.commit("addEventEdate", dataObj.EventEndDate);
        store.commit("addEventEdate", dataObj.EndDateTimeStamp);
        store.commit("addZone", dataObj.TimeZone);
        //store.commit("addZone", dataObj.TimeZone);

        let currentEvent = vm.$store.state.historyEvent;
        if (currentEvent) {
          currentEvent.EventFullName = dataObj.EventFullName;
          currentEvent.EventShortName = dataObj.EventFullName;
          currentEvent.Description = dataObj.Description;
          currentEvent.EventTypeId = dataObj.EventTypeId;
          currentEvent.AllowRegistration = dataObj.AllowRegistration;
          currentEvent.LocationType = dataObj.LocationType;
          currentEvent.TimeZone = dataObj.TimeZone;
          currentEvent.EventStartDate = dataObj.StartDateTimeStamp;
          currentEvent.EventEndDate = dataObj.EndDateTimeStamp;
          currentEvent.EventStartDateTimestamp =
            dataObj.StartDateTimeStamp.seconds;
          currentEvent.EventEndtDateTimestamp =
            dataObj.EndDateTimeStamp.seconds;
          // currentEvent.EventStartDate = dataObj.StartDateTZ;
          // currentEvent.EventEndDate = dataObj.EndDateTZ;
          // currentEvent.EventEndDate = dataObj.StartTimeTZ;
          // currentEvent.EventEndTime = dataObj.EndTimeTZ;
          currentEvent.DefaultLanguage = dataObj.DefaultLanguage;
          currentEvent.EventAccessType = dataObj.EventAccessType;
          vm.$store.state.historyEvent = currentEvent;
        }
        let eventBranding = this.$store.getters.getEventBranding;
        if (eventBranding) {
          eventBranding[0].themeName = vm.appColorHexCodeType;
          eventBranding[0].topBar = vm.headerColorsHexCode.topBar;
          eventBranding[0].headerBar = vm.headerColorsHexCode.headerBar;
          eventBranding[0].fontBar = vm.headerColorsHexCode.fontBar;
          eventBranding[0].sideNavigationAndIconColor =
            vm.headerColorsHexCode.sideNavigationAndIconColor;
          store.commit("addEventBranding", eventBranding[0]);
        }
        let events = store.getters.getMappedEvent;
        if (events && events.length > 0) {
          for (var i = 0; i < events.length; i++) {
            if (events[i].EventId == vm.EventData.EventId) {
              events[i].EventFullName = dataObj.EventFullName;
              events[i].EventShortName = dataObj.EventFullName;
              events[i].Description = dataObj.Description;
              events[i].EventTypeId = dataObj.EventTypeId;
              events[i].AllowRegistration = dataObj.AllowRegistration;
              events[i].LocationType = dataObj.LocationType;
              events[i].TimeZone = dataObj.TimeZone;
              events[i].EventStartDate = dataObj.StartDateTimeStamp;
              events[i].EventEndDate = dataObj.EndDateTimeStamp;
              events[i].EventStartDateTimestamp =
                dataObj.StartDateTimeStamp.seconds;
              events[i].EventEndtDateTimestamp =
                dataObj.EndDateTimeStamp.seconds;
              // events[i].EventStartDate = dataObj.StartDateTZ;
              // events[i].EventEndDate = dataObj.EndDateTZ;
              // events[i].EventEndDate = dataObj.StartTimeTZ;
              // events[i].EventEndTime = dataObj.EndTimeTZ;
              events[i].DefaultLanguage = dataObj.DefaultLanguage;
              events[i].EventAccessType = dataObj.EventAccessType;
              break;
            }
          }
          store.commit("setMappedEvent", events);
        }
      }
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    setBrandingJson(mainKey, subKeyValObj = null) {
      let dataArr = [];
      if (Array.isArray(mainKey)) {
        for (let item of mainKey) {
          //if (typeof item.obj == "object") {
          dataArr.push({
            mainKey: item.key,
            subKeys: Object.keys(item.obj),
            subKeyValObj: item.obj,
          });
          // } else {
          //   dataArr.push({
          //     mainKey: null,
          //     subKeys: item.key,
          //     subKeyValObj: item.obj,
          //   });
          // }
        }
      } else {
        let subKeys = Object.keys(subKeyValObj);
        dataArr.push({
          mainKey: mainKey,
          subKeys: subKeys,
          subKeyValObj: subKeyValObj,
        });
      }
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: dataArr,
      };
      axios.post(APIs.SaveEventBrandingJson, requestData, { headers: headers });
    },
  },
};
</script>